export enum RouteEnum {
  'AdvancedSearch' = 'advancedSearch',
  'AiTutor' = 'aiTutor',
  'Article' = 'article',
  'ArticleCopy' = 'articleCopy',
  'BigOrder' = 'bigOrder',
  'BookStore' = 'bookStore',
  'B2bHomework' = 'b2bHomework',
  'B2bHomeworkEntry' = 'b2bHomeworkEntry',
  'B2bHomeworkWriting' = 'b2bHomeworkWriting',
  'B2bHomeworkWritingLog' = 'b2bHomeworkWritingLog',
  'B2bHomeworkReadWork' = 'b2bHomeworkReadWork',
  'B2bHomeworkConversation' = 'b2bHomeworkConversation',
  'B2bHomeworkConversationWork' = 'b2bHomeworkConversationWork',
  'B2bHomeworkConversationLog' = 'b2bHomeworkConversationLog',
  'Calendar' = 'calendar',
  'CefrTest' = 'cefrTest',
  'Collection' = 'collection',
  'Consulting' = 'consulting',
  'ContractTermination' = 'contractTermination',
  'CourseRecord' = 'courseRecord',
  'CourseVideo' = 'courseVideo',
  'CustomHomePage' = 'customHomePage',
  'DeleteAccount' = 'deleteAccount',
  'DiaryEdit' = 'diaryEdit',
  'DiaryOpenLink' = 'diaryOpenLink',
  'DiaryView' = 'diaryView',
  'Donation' = 'donation',
  'FAQ' = 'FAQ',
  'FunCoin' = 'funCoin',
  'FunTv' = 'funTv',
  'Homework' = 'homework',
  'Index' = 'index',
  'Landing' = 'landing',
  'LandingBranding' = 'branding',
  'LandingElite' = 'MZlink',
  'LandingEliteList' = 'MZlink-list',
  'LandingRegisterSingle' = 'LPlink',
  'LandingSocialCoffeeGift' = 'socialCoffeeGift',
  'LandingSocialCommon' = 'socialCommon',
  'LearningProgress' = 'learningProgress',
  'LearningStatistics' = 'learningStatistics',
  'Lesson' = 'lesson',
  'LineBinding' = 'lineBinding',
  'Listening' = 'listening',
  'ListeningTest' = 'listeningTest',
  'Live' = 'live',
  'LiveNow' = 'liveNow',
  'LiveRoom' = 'liveRoom',
  'Login' = 'login',
  'LoginCommon' = 'loginCommon',
  'LoginJunior' = 'loginJunior',
  'LoginMusicTube' = 'loginMusicTube',
  'LoginReading' = 'loginReading',
  'MLM' = 'mlm',
  'NewHomework' = 'newHomework',
  'NewHomeworkConversation' = 'newHomeworkConversation',
  'NewHomeworkConversationLog' = 'newHomeworkConversationLog',
  'NewHomeworkConversationWork' = 'newHomeworkConversationWork',
  'NewHomeworkEntry' = 'newHomeworkEntry',
  'NewHomeworkReadWork' = 'newHomeworkReadWork',
  'NewHomeworkWriting' = 'newHomeworkWriting',
  'NewHomeworkWritingLog' = 'newHomeworkWritingLog',
  'OrderPlan' = 'orderPlan',
  'OrderRecord' = 'orderRecord',
  'PartnersView' = 'partners',
  'PaymentResult' = 'paymentResult',
  'PolicyTerms' = 'policyAndTerms',
  'ProfileSetup' = 'profileSetup',
  'Reading' = 'reading',
  'ReadingRecord' = 'readingRecord',
  'Review' = 'review',
  'Root' = 'root',
  'Schedule' = 'schedule',
  'Sitemap' = 'sitemap',
  'Speaking' = 'speaking',
  'SpecialOrderPlan' = 'specialOrderPlan',
  'StudentTestimonialsLanding' = 'studentTestimonials',
  'StudentTestimonialsSharing' = 'studentTestimonialsShare',
  'Subscription' = 'subscription',
  'ThankYou' = 'thankYou',
  'ThirdPartySMSVerify' = 'thirdPartySMSVerify',
  'Today' = 'today',
  'Toeic' = 'toeic',
  'ToeicCertificate' = 'toeicCertificate',
  'ToeicExam' = 'toeicExam',
  'ToeicRecord' = 'toeicRecord',
  'UsageRecord' = 'usageRecord',
  'VideoLibrary' = 'videoLibrary',
  'WeeklyTest' = 'weeklyTest',
  'WeeklyTestRecord' = 'weeklyTestRecord',
  'Writing' = 'writing'
}
